import {
  Stepper,
  Form,
  Email,
  PhoneNumber,
  NameTextField,
  TextField,
  Button,
  Checkbox,
  Select,
  City,
  Hidden,
} from "@lmt/taskforce-react-form";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { checkboxClasses } from '@mui/material/Checkbox';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { styled } from "@mui/material/styles";

const Text = styled("div")(({ theme }) => ({
  fontFamily: "Roboto,Arial,Helvetica,sans-serif",
}));

const theme = createTheme({
  components: {
      MuiButton: {
        defaultProps: {
            size: "large",
        },
        styleOverrides: {
            root: {
                borderRadius: 6,
                backgroundColor: "#FFCD00",
                fontSize: "14px",
                fontWeight: "bold",
                color: "#000000",
                textTransform: "none",
                paddingTop: "10px",
                paddingBottom: "10px",
                minWidth: "110px",
                width: "300px",
                "&:hover": {
                    backgroundColor: "#FFCD00",
                },
            },
        },
    },
    MuiButtonGroup: {
      defaultProps: {
        size: "small",
      },
    },
    MuiCheckbox: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
            color: "#555555",
            [`&.${checkboxClasses.checked}`]: {
              color: "#000000",
            },
        },
      },
    },
    MuiFormControl: {
      defaultProps: {
        margin: "dense",
        size: "small",
      },
    },
    MuiFormHelperText: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiInputBase: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiInputLabel: {
      defaultProps: {
        margin: "dense",
      },
      styleOverrides: {
        root: {
            color: "#000000",
            '&.Mui-focused': {
              color: '#000000',
            },
            '& .MuiInputLabel-asterisk': {
              color: '#FFCD00',
            },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#000000',
          },
        },
      },
    },
    MuiRadio: {
      defaultProps: {
        size: "small",
      },
    },
    MuiTextField: {
      defaultProps: {
        margin: "dense",
        size: "medium",
      },
    },
    MuiSelect: {
      styleOverrides: {
        outlined: {
          padding: "12px 12.5px",
        },
      },
    },  
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Stepper
        steps={[
          <Form onSubmit={({origin}) => (window.top.location.href = `${origin}/good.php`) } >
            <Box mt={-0.5}>
              <NameTextField
                label="Nom"
                name="last_name"
                required="Champ obligatoire"
                validatorMessage="Nom incorrect"
                variant="outlined"
              />
            </Box>

            <Box mt={-0.5}>
              <NameTextField
                label="Prénom"
                name="first_name"
                required="Champ obligatoire"
                validatorMessage="Prénom incorrect"
                variant="outlined"
              />
            </Box>

            <Box mt={-0.5}>
              <PhoneNumber
              label="Téléphone"
              name="phone_number_mobile"
              required="Champ obligatoire"
              validatorMessage="Téléphone incorrect"
              variant="outlined"
              />
            </Box>

            <Box mt={-0.5}>
              <Email
              label="Email"
              name="email"
              required="Champ obligatoire"
              validatorMessage="Email incorrect"
              variant="outlined"
              />
            </Box>
        
            <Box mt={-0.5}>
              <City
                label="Code postal"
                name="zipcode"
                required="Champ obligatoire"
                variant="outlined"
              /> 
            </Box>
            
            <Box mt={-0.5}>
              <Select
                label="Quelle énergie vous intéresse ?"
                name="url"
                required={false}
                inline
                variant="outlined"
                items={[
                  { label: "Électricité", value: "Electricite" },
                  { label: "Gaz", value: "Gaz" },
                  { label: "Électricité+Gaz", value: "ElectricitePlusGaz" },
                ]}
              />
            </Box>
            
            <Box sx={{ textAlign: "justify" }} mt={-0.1}>
                <span style={{fontFamily: "Roboto, Arial, Helvetica, sans-serif", fontSize: "11px"}}>
                    En Validant ce formulaire, vous acceptez que les données personnelles saisies sur le formulaire ci-dessus soient transmises à Plenitude pour être contacté par un téléconseiller Plenitude afin de vous présenter nos offres d’énergie. Plus de détail dans les mentions légales en bas de page.
                </span>
            </Box>
            
            
            <Hidden name="origin"/>
            <Box sx={{ display: 'flex', justifyContent: 'center' }} mt={3}>
              <Button labelValidStep="Je valide mon formulaire de rappel" />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", color: "#000000", fontSize: "10px", marginTop: "20px", textAlign: "center",}}>
                <Text><span style={{ color: "#FFCD00" }}>*</span> Champs obligatoires</Text>
            </Box>
            
          </Form>,
        ]}
      />
    </ThemeProvider>
  );
}

export default App;
